import axios from "axios";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import VanillaOTP from "./classes/VanillaOTP";
import { app } from "modular-openscriptjs";
import { App } from "@capacitor/app";
import { Preferences } from "@capacitor/preferences";
import { checkForAppUpdate } from "./appUpdate";

window.isLoggedIn = window.isLoggedIn ?? false;
window.currentUser = window.currentUser ?? {};
window.isEmployee = window.isEmployee ?? false;
window.requiredOtp = window.requiredOtp ?? false;
window.verifiedOtp = window.verifiedOtp ?? false;
window.csrf = window.csrf ?? "";
window.baseUrl = window.baseUrl ?? "";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.VanillaOTP = VanillaOTP;
window.Pusher = Pusher;

if (import.meta.env.VITE_REVERB_APP_KEY) {
    window.Echo = new Echo({
        broadcaster: "reverb",
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? "https") === "https",
        enabledTransports: ["ws", "wss"],

        channelAuthorization: {
            customHandler: (params, callback) => {
                (async () => {
                    const token = await Preferences.get({ key: "auth_token" });

                    if (!token) {
                        callback(true, { message: "Unauthorized" });
                        return;
                    }

                    axios
                        .post(
                            (import.meta.env.VITE_API_BASE_URL ?? "") +
                                "/broadcasting/auth",
                            {
                                socket_id: params.socketId,
                                channel_name: params.channelName,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${token.value}`,
                                    Accept: "application/json",
                                },
                            },
                        )
                        .then((response) => {
                            callback(false, response.data);
                        })
                        .catch((error) => {
                            callback(true, error);
                        });
                })();
            },
        },
    });
} else {
    console.warn("Echo (Pusher) not instantiated: VITE_REVERB_APP_KEY is missing from environment variables.");
}

App.addListener("appUrlOpen", function (event) {
    const url = event.url;

    if (url.startsWith("https://app.carata.co")) {
        const path = new URL(url).pathname;
        app("router").to(path);
    }
});

App.addListener("appStateChange", (state) => {
	if (state.isActive) {
		app("gc").appInForeground.value = true;
		// Re-check on every resume too, so a flexible update that
		// finished downloading in the background gets installed
		// automatically, and a stalled immediate update can resume.
		checkForAppUpdate();
	} else {
		app("gc").appInForeground.value = false;
	}
});

// Check for an update on startup and, if one is available, install it
// automatically (see ./appUpdate.js).
checkForAppUpdate();

import "./declarations";
import "./global-config";
import "./firebase";
import "./mediators";
import "./ojs.routes";
import "./boot";
